import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import DataGrid from '../../../data/Grid';
import deepMerge from '../../../utils/deepMerge';
var defaultGridProps = {
  mode: 'thumbnail',
  viewProps: {
    hideModeSwitcher: true
  },
  styles: {
    elevation: 0,
    noMarginLeft: true
  }
};
/**
 * @param {import('../types').FormInputDataGridSelectProps } props
 */

var DataGridSelectFormInput = function DataGridSelectFormInput(_ref) {
  var onChange = _ref.onChange,
      multi = _ref.multi,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["onChange", "multi", "color"]);

  var onSelect = function onSelect(e, selection, selectionIds) {
    var selectedItems = multi ? selection : selection[0];
    var value = multi ? selectionIds : selectionIds[0];
    onChange(value, selectedItems, e);
  };

  var dataGridProps = deepMerge(defaultGridProps, rest);

  if (color) {
    dataGridProps = deepMerge(dataGridProps, {
      styles: {
        selectionColor: color
      }
    });
  }

  return React.createElement(DataGrid, Object.assign({
    onSelect: onSelect,
    selectable: true,
    multiSelection: multi,
    contextMenu: false,
    defaultSelection: []
  }, dataGridProps));
};

DataGridSelectFormInput.defaultProps = {
  multi: false
};
export default DataGridSelectFormInput;